"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { MessageSquare, Clock, Bell } from "lucide-react"
import { useNotification } from "@/contexts/NotificationContext"

// カスタムシフトアイコン
const ShiftIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <rect x="7" y="14" width="3" height="3" />
    <rect x="14" y="14" width="3" height="3" />
  </svg>
)

// カスタム指令アイコン
const CommandIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="6" width="20" height="12" rx="2" />
    <circle cx="12" cy="12" r="2" />
    <path d="m4.93 19.07 4.24-4.24" />
    <path d="m14.83 9.17 4.24-4.24" />
    <path d="m14.83 14.83 4.24 4.24" />
    <path d="m4.93 4.93 4.24 4.24" />
  </svg>
)

export default function Navigation() {
  const pathname = usePathname()

  // Context経由で通知件数を取得（staffでは通知・タスク・メッセージ全て使用）
  const { noticeCount, taskCount, messageCount } = useNotification()

  const navItems = [
    {
      name: "通知",
      href: "/",
      icon: Bell,
      badgeCount: noticeCount,
    },
    // TODO: タスクタブは非表示（復活時はこのエントリのコメントアウトを解除する）
    // {
    //   name: "タスク",
    //   href: "/commands",
    //   icon: CommandIcon,
    //   badgeCount: taskCount,
    // },
    {
      name: "シフト",
      href: "/shift",
      icon: ShiftIcon,
      badgeCount: 0,
    },
    {
      name: "チャット",
      href: "/messages",
      icon: MessageSquare,
      badgeCount: messageCount,
    },
    {
      name: "ログ",
      href: "/logs",
      icon: Clock,
      badgeCount: 0,
    },
  ]

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 dark:bg-gray-950 dark:border-gray-800">
      {/* 通知/シフト/チャット/ログ の4要素を1行で配置（ログは最右）。管理・ログアウトはヘッダーのメニューへ集約 */}
      <div className="grid grid-cols-4">
        {navItems.map((item) => {
          const isActive = pathname === item.href
          return (
            <Link
              key={item.href}
              href={item.href}
              className={`flex flex-col items-center justify-center h-16 relative ${
                isActive
                  ? "text-primary"
                  : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
              }`}
            >
              <div className="relative">
                <item.icon className="h-5 w-5 mb-1" />
                {/* バッジ表示 */}
                {item.badgeCount > 0 && (
                  <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
                    {item.badgeCount > 99 ? "99+" : item.badgeCount}
                  </div>
                )}
              </div>
              <span className="text-xs">{item.name}</span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
